(() => {
  const tabs = [...document.querySelectorAll('[role="tab"][data-mode]')];
  const selectMode = tab => {
    tabs.forEach(item => {
      const active = item === tab;
      item.classList.toggle('is_active', active);
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      panel.hidden = !active;
      panel.classList.toggle('is_active', active);
      panel.classList.remove('is_entering');
      if (active) {
        // 同じパネルを再表示したときもアニメーションを再実行する。
        void panel.offsetWidth;
        panel.classList.add('is_entering');
      }
    });
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => selectMode(tab));
    tab.addEventListener('keydown', event => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
      event.preventDefault();
      const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      selectMode(tabs[nextIndex]);
      tabs[nextIndex].focus();
    });
  });

  const tingleTrack = document.querySelector('.bl_tingle_track');
  const tingleSlides = [...tingleTrack.children];
  const tinglePrev = document.querySelector('.js_tinglePrev');
  const tingleNext = document.querySelector('.js_tingleNext');
  const tingleThumbs = [...document.querySelectorAll('.bl_tingle_thumb')];
  const tingleCurrent = document.querySelector('.js_tingleCurrent');
  const tingleProgress = document.querySelector('.bl_tingle_progress span');
  let currentSlide = 0;
  let carouselInteracted = false;
  const resetInitialSlide = () => {
    if (carouselInteracted) return;
    tingleTrack.classList.add('is_resetting');
    tingleTrack.scrollLeft = 0;
    updateCarousel(0);
    requestAnimationFrame(() => {
      tingleTrack.scrollLeft = 0;
      tingleTrack.classList.remove('is_resetting');
    });
  };
  const updateCarousel = index => {
    currentSlide = Math.max(0, Math.min(tingleSlides.length - 1, index));
    tingleCurrent.textContent = String(currentSlide + 1).padStart(2, '0');
    tingleProgress.style.transform = `translateX(${currentSlide * 100}%)`;
    tinglePrev.disabled = currentSlide === 0;
    tingleNext.disabled = currentSlide === tingleSlides.length - 1;
    tingleThumbs.forEach((thumb, thumbIndex) => {
      const active = thumbIndex === currentSlide;
      thumb.classList.toggle('is_active', active);
      thumb.setAttribute('aria-current', String(active));
    });
  };
  const goToSlide = index => {
    carouselInteracted = true;
    const slide = tingleSlides[Math.max(0, Math.min(tingleSlides.length - 1, index))];
    tingleTrack.scrollTo({ left: slide.offsetLeft - tingleSlides[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    updateCarousel(index);
  };
  tinglePrev.addEventListener('click', () => goToSlide(currentSlide - 1));
  tingleNext.addEventListener('click', () => goToSlide(currentSlide + 1));
  tingleThumbs.forEach(thumb => thumb.addEventListener('click', () => goToSlide(Number(thumb.dataset.slide))));
  tingleTrack.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    goToSlide(currentSlide + (event.key === 'ArrowRight' ? 1 : -1));
  });
  tingleTrack.addEventListener('touchstart', () => { carouselInteracted = true; }, { passive:true });
  tingleTrack.addEventListener('wheel', () => { carouselInteracted = true; }, { passive:true });
  let tingleScrollFrame;
  tingleTrack.addEventListener('scroll', () => {
    cancelAnimationFrame(tingleScrollFrame);
    tingleScrollFrame = requestAnimationFrame(() => {
      const scrollLeft = tingleTrack.scrollLeft;
      const firstLeft = tingleSlides[0].offsetLeft;
      const closest = tingleSlides.reduce((best, slide, index) =>
        Math.abs(slide.offsetLeft - firstLeft - scrollLeft) < Math.abs(tingleSlides[best].offsetLeft - firstLeft - scrollLeft) ? index : best, 0);
      updateCarousel(closest);
    });
  }, { passive:true });

  // PCでは画像をつかんで送れるようにする。SPのタッチ操作は標準のスクロールに任せる。
  let mouseDrag = null;
  tingleTrack.addEventListener('dragstart', event => event.preventDefault());
  tingleTrack.addEventListener('pointerdown', event => {
    if (event.pointerType !== 'mouse' || event.button !== 0 || window.matchMedia('(max-width: 767px)').matches) return;
    carouselInteracted = true;
    mouseDrag = { id:event.pointerId, startX:event.clientX, startScroll:tingleTrack.scrollLeft, startIndex:currentSlide };
    tingleTrack.classList.add('is_dragging');
    tingleTrack.setPointerCapture(event.pointerId);
    event.preventDefault();
  });
  tingleTrack.addEventListener('pointermove', event => {
    if (!mouseDrag || event.pointerId !== mouseDrag.id) return;
    tingleTrack.scrollLeft = mouseDrag.startScroll + mouseDrag.startX - event.clientX;
    event.preventDefault();
  });
  const endMouseDrag = event => {
    if (!mouseDrag || event.pointerId !== mouseDrag.id) return;
    const distance = event.type === 'pointercancel' ? 0 : mouseDrag.startX - event.clientX;
    const startIndex = mouseDrag.startIndex;
    mouseDrag = null;
    tingleTrack.classList.remove('is_dragging');
    const threshold = Math.max(24, tingleTrack.clientWidth * .06);
    goToSlide(startIndex + (Math.abs(distance) >= threshold ? Math.sign(distance) : 0));
  };
  tingleTrack.addEventListener('pointerup', endMouseDrag);
  tingleTrack.addEventListener('pointercancel', endMouseDrag);

  resetInitialSlide();
  window.addEventListener('load', resetInitialSlide, { once:true });
  window.addEventListener('pageshow', resetInitialSlide);

  const hero = document.querySelector('.bl_hero');
  requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('is_ready')));

  const revealElements = [...document.querySelectorAll('.js_revealUp, .js_revealFade')].filter(element => !element.closest('.bl_hero'));
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is_visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
    revealElements.forEach(element => observer.observe(element));
  } else {
    revealElements.forEach(element => element.classList.add('is_visible'));
  }

  const toTop = document.querySelector('.bl_toTop');
  const footer = document.querySelector('.bl_footer');
  let toTopFrame = 0;
  let savedScrollBehavior = '';
  toTop.addEventListener('click', event => {
    event.preventDefault();
    if (toTopFrame) cancelAnimationFrame(toTopFrame);
    else savedScrollBehavior = document.documentElement.style.scrollBehavior;

    const startY = window.scrollY || document.documentElement.scrollTop;
    if (startY <= 0) {
      document.documentElement.style.scrollBehavior = savedScrollBehavior;
      toTopFrame = 0;
      return;
    }

    // CSS の scroll-behavior や端末設定に左右されない速度で戻す。
    const root = document.documentElement;
    root.style.scrollBehavior = 'auto';
    const duration = Math.min(1400, Math.max(800, startY / 5));
    const startedAt = performance.now();
    const step = now => {
      const progress = Math.min((now - startedAt) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, Math.round(startY * (1 - eased)));
      if (progress < 1) {
        toTopFrame = requestAnimationFrame(step);
      } else {
        root.style.scrollBehavior = savedScrollBehavior;
        toTopFrame = 0;
      }
    };
    toTopFrame = requestAnimationFrame(step);
  });
  const updateToTop = () => {
    toTop.classList.toggle('is_visible', window.scrollY > window.innerHeight * .6);
    document.body.style.setProperty('--footer-height', `${footer.offsetHeight}px`);
    toTop.classList.toggle('is_atFooter', footer.getBoundingClientRect().top <= window.innerHeight);
  };
  window.addEventListener('scroll', updateToTop, { passive:true });
  window.addEventListener('resize', updateToTop);
  updateToTop();
})();
